import Backbone from 'backbone';
import action from './action';
import { uniq, flatten, sortBy } from 'lodash';

const actionsCollection = Backbone.Collection.extend({
  initialize: function(){
    this.url = '/actions';
    this.model = action;
  },

  categories: function(){
    return uniq(this.models.map(function(model){
      return model.get('category');
    }))
  },

  alphabetical: function(){
    return sortBy(this.models, function(action){
      return action.get('name');
    });
  },

  tags: function() {
    return uniq(flatten(this.models.map((item) => {
      return item.attributes.tags.map(tag => tag.name);
    })))
  }
});

export default actionsCollection;
